/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAddContactInfo, ICheckoutGuestProfileViewProps, IShowContactInfo } from './checkout-guest-profile-emarsys';

export const ShowContactInfo: React.FC<IShowContactInfo> = ({ showInfoProps, email, editButton }) => (
    <Node {...showInfoProps}>
        {email}
        {editButton}
    </Node>
);

export const AddContactInfo: React.FC<IAddContactInfo> = ({
    addFormProps,
    submitButton,
    cancelButton,
    inputGroupProps,
    label,
    error,
    input
}) => (
    <Node {...addFormProps}>
        <Node {...inputGroupProps}>
            {'Email Address'}
            {error}
            {input}
        </Node>
        {submitButton}
        {cancelButton}
    </Node>
);

const CheckoutGuestProfileView: React.FC<ICheckoutGuestProfileViewProps> = ({ moduleProps, showContactInfo, addContactInfo, checkBox, reCaptcha}) => {
    return (
        <Module {...moduleProps}>
            {showContactInfo && <ShowContactInfo {...showContactInfo} />}
            {addContactInfo && <AddContactInfo {...addContactInfo} />}
            {checkBox}
            {reCaptcha}
        </Module>
    );
};

export default CheckoutGuestProfileView;
